import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Star } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { API, errMsg } from "@/lib/api";

export const StarPicker = ({ value, onChange }) => (
  <div className="flex gap-1" data-testid="review-star-picker">
    {[1, 2, 3, 4, 5].map((n) => (
      <button type="button" key={n} onClick={() => onChange(n)} data-testid={`review-star-${n}`} aria-label={`${n} stars`}
        className="transition-transform hover:scale-125">
        <Star className={`h-8 w-8 ${n <= value ? "fill-[#f5b82e] text-[#f5b82e]" : "text-slate-300"}`} />
      </button>
    ))}
  </div>
);

export const ReviewDialog = () => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", rating: 5, text: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/reviews`, form);
      toast.success(data.message);
      setForm({ name: "", rating: 5, text: "" });
      setOpen(false);
    } catch (err) { toast.error(errMsg(err)); }
    setBusy(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button data-testid="submit-review-modal-trigger"
          className="btn-pop shadow-chunky rounded-full bg-teal-600 px-6 py-3 text-sm font-bold text-white">Write a review</button>
      </DialogTrigger>
      <DialogContent className="rounded-3xl">
        <DialogHeader><DialogTitle className="font-display text-2xl">Share your Tooth Buds story</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4" data-testid="submit-review-form">
          <StarPicker value={form.rating} onChange={(rating) => setForm({ ...form, rating })} />
          <Input required placeholder="Your name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="review-name-input" />
          <Textarea required minLength={5} rows={4} placeholder="How was your child's visit?" value={form.text}
            onChange={(e) => setForm({ ...form, text: e.target.value })} data-testid="review-text-input" />
          <button disabled={busy} data-testid="review-submit-button"
            className="w-full rounded-full bg-[#ff6b6b] py-3 font-bold text-white disabled:opacity-60">{busy ? "Sending..." : "Submit review"}</button>
          <p className="text-center text-xs text-slate-400">Reviews appear after a quick check by the clinic.</p>
        </form>
      </DialogContent>
    </Dialog>
  );
};
